module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi41IiBoZWlnaHQ9IjI3IiB2aWV3Qm94PSIwIDAgMjIuNSAyNyI+DQogIDxwYXRoIGlkPSJJY29uX2lvbmljLW1kLXRyYXNoIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtbWQtdHJhc2giIGQ9Ik05LDI4LjUwN0EzLjAwNSwzLjAwNSwwLDAsMCwxMiwzMS41SDI0YTMuMDA1LDMuMDA1LDAsMCwwLDMtMi45OTNWMTEuMjVIOVpNMjkuMjUsNi43NUgyMy42MjVMMjEuNzQyLDQuNUgxNC4yNThMMTIuMzc1LDYuNzVINi43NVY5aDIyLjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi43NSAtNC41KSIgZmlsbD0iI2ZjNDUxMyIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/Icon ionic-md-trash.svg
// module id = 1768
// module chunks = 1